/* eslint-disable import/no-default-export */
import {CartController} from './CartController';
import {controllerFactory as oldControllerFactory} from '@wix/wixstores-client-storefront-sdk';
import {conditionalController} from '../../domain/controllers/conditionalController';
import {SPECS} from '../../domain/specs';
import {ControllerConstructorType} from '../../types/app.types';
import {controllerFactory} from './controllerFactory';

export const conditionalCartControllerFactory = (controller: ControllerConstructorType<CartController>) =>
  conditionalController(
    SPECS.UseNewControllerFactoryInCart,
    controllerFactory(controller),
    oldControllerFactory(controller, {shouldCallAppSettingsOnlyWhenMultilingualIsNeeded: true})
  );

export default conditionalCartControllerFactory(CartController);
